import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'

export const LeftContainer = styled.View`
  display: flex;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
`

export const RightContainer = styled.View`
  display: flex;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
`

export const ColumnContainer = styled.View`
  flex-direction: column;
  width: 100%;
`

export const PostContainerLeft = styled.View`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
`

export const PostContainerRight = styled.View`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row-reverse;
`

export const MarkdownContainer = styled.View`
  margin-vertical: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  padding-left: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  max-width: ${({ theme }) =>
    theme.isBigScreen ? theme.metrics.web.postDescriptionMaxWidth : '240'}px;
`
export const DateContainer = styled.View`
  margin-top: ${({ theme }) => theme.metrics.baseMargin / 2};
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin};
`

export const DateText = styled(Typography)`
  text-align: center;
`

export const ErrorText = styled(Typography)`
  text-align: right;
`
//Using a View containter to avoid setting line-height on Typography which could potentially break accessibility features like font scaling.
export const NameContainer = styled.View`
  min-height: ${({ theme }) => theme.metrics.baseMargin}px;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

export const LeftName = styled(Typography)``
